<template>
  <div>
  <div slot="modal-body">
    <p v-if="showSuccess">Hashtags added successfully</p>
    <div v-if="!showSuccess">
    
     <b-dropdown variant="default" :text='this.setNames' class="footer-dropdown">
            <div v-for="set in getHashtagSets" :key="set.index">
              <b-dropdown-item @click="addSet(set)">{{set.name}}</b-dropdown-item>
            </div>
          </b-dropdown>
    <br>
      <b-alert variant="danger" v-if="showError">Oops, something went wrong..</b-alert>
    </div>
    <div class="modal-footer">
         
      <b-btn variant="primary" @click="addSelectedSets(addedHashtags)">Add selected set</b-btn>
    </div>
  </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  export default {
    name: 'AddHashtagSet',
    mounted() {
        this.getHashtags() 
    },
    data () {
      return {
        showInput: true,
        showSuccess: false,
        showError: false,
        setNames: "Select hashtag sets",
        addedHashtags: []
      }
    },
    
    methods: {
      ...mapActions('hashtagSets', [
          'setBookmarkHashtag',
          'setCompareSuggestedHashtags',
            'changeSetToBeEdited',
          'setHashtagSets'
      ]),
      getHashtags () {
          this.setHashtagSets();
          return this.getHashtagSets
      },
      addSelectedSets (tags) {
        this.$emit('addedHashtagSet', tags)
        this.showSuccess = true
        this.setNames = "Select hashtag sets"
        this.addedHashtags = []
        this.$root.$emit('bv::hide::modal','modal2')
        this.showSuccess = false
      },
      addSet (set) {
        for (let i = 0; i < this.setNames.length; i++) {
          if (this.setNames[i] === set.name) {
            return
          }
        }
          this.setNames = set.name
          this.addedHashtags = []
          for (let i = 0; i < set.tags.length; i++) {
            this.addedHashtags.push(set.tags[i])
          }
      },
      removeSet (setName) {
        for (let i = 0; i < this.setNames.length; i++) {
          if (this.setNames[i] === setName) {
            this.setNames.splice(i, 1)
          }
        }
      }
    },
    computed: {
      ...mapGetters('hashtagSets',['getHashtagSets'])
    }
  }
</script>

<style scoped>
  .set-name {
    margin-left: 15px;
  }
  .set-btn {
    border: none;
  }
  .footer-dropdown {
    margin-right: 105px;
  }
  .modal-body {
    padding: 0.8rem 0.8rem 0.5rem;
  }
</style>
